<nb-card>
  <nb-card-header>{{ title }}</nb-card-header>
  <nb-card-body *ngIf="description">
    <p style="white-space: pre-line">{{ description }}</p>
  </nb-card-body>
  <nb-card-footer>
    <button class="cancel" nbButton status="warning" (click)="cancel()">
      Không
    </button>
    <button nbButton status="primary" (click)="submit(true)">Có</button>
  </nb-card-footer>
</nb-card>
